module.exports = __webpack_public_path__ + "static/pruvodce-02db9cff420204906514d68645467754.pdf";